const stepsMixin = {
  props: {
    stepName: {
      type: String,
    },
  },
  data() {
    return {
      googleVerifyKey: null,
      showRecaptcha: false,
      form: {},
    };
  },
  computed: {
    step() {
      return this.$store.getters['supplier/getStep'](this.stepName);
    },
  },
  methods: {
    async handleSubmit(validCallback) {
      const isValid = await this.$refs.form.validate();
      this.form.isCompleted = isValid;

      if (isValid) {
        if (typeof validCallback === 'function') {
          await validCallback();
        }

        await this.saveStep();
        await this.setSteps();
        await this.setSavedApplicationId();
        await this.setRoute();
      }

      this.setNotify({ isValid });
    },
    async setSteps() {
      await this.$store.commit('supplier/setStep', {
        stepName: this.stepName,
        step: this.form,
      });
    },
    async saveStep() {
      const steps = {
        ...this.$store.getters['supplier/getAllSteps'],
        [this.stepName]: this.form,
      };
      await this.$store.commit('setIsAppLoading', true);
      await this.$store.dispatch('supplier/saveSteps', steps);
      await this.$store.commit('setIsAppLoading', false);
    },
    async setSavedApplicationId() {
      const allStepsIsCompleted = this.$store.getters[
        'supplier/getAllStepsCompleted'
      ];
      const id = !allStepsIsCompleted
        ? this.$store.getters['supplier/getId']
        : null;

      if (allStepsIsCompleted) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          Category: 'Homepage',
          Action: 'Başarılı Kayıt',
          Label: 'Tedarikçi',
          event: 'gaEvent',
        });
      }

      await this.$store.commit('supplier/setSavedApplicationId', id);
    },
    async setRoute() {
      return new Promise(resolve => {
        const id = this.$store.getters['supplier/getId'];
        const route = {
          name: 'applications.supplier',
          params: {
            id,
          },
        };
        const newPath = this.$router.resolve(route).route.path;
        const currentRoutePath = this.$route.path;

        if (newPath !== currentRoutePath) {
          resolve(
            this.$router.push({
              name: 'applications.supplier',
              params: {
                id,
              },
            })
          );
        } else {
          resolve(true);
        }
      });
    },
    setNotify({ isValid }) {
      if (isValid) {
        this.$notify({
          title: `${this.form.step} Formu`,
          text: 'Form başarıyla kaydedildi',
          type: 'success',
        });
        setTimeout(() => {
          this.$scrollTo('body');
        });
      } else {
        this.$notify({
          title: `${this.form.step} Formu`,
          text: 'Lütfen formdaki bütün zorunlu alanları doldurunuz.',
          type: 'danger',
          ignoreDuplicates: true,
        });
        setTimeout(() => {
          this.$scrollTo('.form_group_wrapper__error', { offset: -20 });
        });
      }
    },
  },
  watch: {
    step: {
      handler() {
        this.form = JSON.parse(JSON.stringify(this.step));
      },
      deep: true,
    },
  },
  created() {
    this.googleVerifyKey = this.$store.getters['supplier/getId']
      ? this.$store.getters['getGoogleVerifyKey']
      : null;
    this.showRecaptcha = !this.googleVerifyKey;

    this.form = JSON.parse(JSON.stringify(this.step));
  },
};

export default stepsMixin;
